"use client";

import React from "react";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const curriculumPoints = ["Cele 10 domenii validate cu potențial real în Moldova și diaspora", "Cum alegi direcția potrivită pentru personalitatea, bugetul și timpul tău", "De ce promovarea nu îți aduce clienți și ce trebuie făcut diferit", "Modelul simplu de vânzare într-o piață aglomerată", "Greșelile care blochează profitul în primele luni"];
export default function CurriculumWebinarSiUrgenta() {
  const {
    ref: sectionRef,
    isVisible: isSectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="curriculum-webinar-și-urgență" className="dark bg-background text-foreground py-20 overflow-hidden container" ref={sectionRef} data-animate={isSectionVisible ? "" : undefined}>
      <div className="flex flex-col items-center">
        <h2 className="text-2xl font-bold text-center tracking-tight font-sans text-foreground ![margin:0px_0px_10px_0px] md:text-3xl lg:text-4xl">În cadrul cursului vei învăța:</h2>

        <div className="flex flex-col items-center mb-12 w-full max-w-2xl">
          <p className="text-lg md:text-xl font-medium text-center mb-6 text-foreground/90 font-sans">Totul explicat simplu și aplicat pe exemple reale.</p>
          
          <Link to="#">
            {}
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full mt-8">
          {curriculumPoints.map((point, i) => <div key={i} data-index={i} className="card p-6 flex items-start gap-5 transition-all duration-300 group md:p-8 hover:scale-[1.02]">
              <div className="bg-background/40 border border-white/10 p-2.5 rounded-full shrink-0 mt-1 group-hover:bg-primary/20 group-hover:ring-2 group-hover:ring-primary/30 transition-all duration-300">
                <Check className="w-5 h-5 text-primary group-hover:text-primary transition-colors duration-300" />
              </div>
              <p className="text-foreground/90 text-base md:text-lg leading-relaxed font-medium font-sans">Cum să lansezi reclame profitabile</p>
            </div>)}
        </div>
        
        
      </div>
    </section>;
}